"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useEffect, useRef } from "react";
import { TransitionRouter } from "next-transition-router";
import gsap from "gsap";
import DrawSVGPlugin from "gsap/DrawSVGPlugin";
gsap.registerPlugin(DrawSVGPlugin);
const TransitionWrapper = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  const transitionOverlayRef = useRef(null);
  const svgPathRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (svgPathRef.current) {
        gsap.set(svgPathRef.current, {
          drawSVG: "0%",
          strokeWidth: 2
        });
      }
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = next => {
      const tl = gsap.timeline({
        onComplete: next
      });
      tl.to(transitionOverlayRef.current, {
        opacity: 1,
        duration: 0.5,
        ease: "power2.inOut"
      }).to(svgPathRef.current, {
        drawSVG: "100%",
        strokeWidth: 300,
        duration: 1.5,
        ease: "power2.inOut"
      }, 0);
      return () => tl.kill();
    };
    t4 = next_0 => {
      const tl_0 = gsap.timeline({
        onComplete: next_0
      });
      tl_0.to(svgPathRef.current, {
        drawSVG: "100% 100%",
        strokeWidth: 2,
        duration: 1.5,
        ease: "power2.inOut"
      }).to(transitionOverlayRef.current, {
        opacity: 0,
        duration: 0.5,
        ease: "power2.inOut"
      }, 1).set(svgPathRef.current, {
        drawSVG: "0%",
        strokeWidth: 2
      });
      return () => tl_0.kill();
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div ref={transitionOverlayRef} className="fixed inset-0 pointer-events-none z-999 flex items-center justify-center opacity-0"><svg width="100%" height="100%" viewBox="0 0 1316 664" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full scale-130 h-full" preserveAspectRatio="xMidYMid slice"><path ref={svgPathRef} d="M13.4746 291.27C13.4746 291.27 100.646 -18.6724 255.617 16.8418C410.588 52.356 61.0296 431.197 233.017 546.326C431.659 679.299 444.494 21.0125 652.73 100.784C860.967 180.556 468.663 430.709 617.216 546.326C765.769 661.944 819.097 48.2722 988.501 120.156C1174.21 198.957 809.424 543.841 988.501 636.726C1189.37 740.915 1301.67 149.213 1301.67 149.213" stroke="#b2d127" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children) {
    t6 = <TransitionRouter auto={true} leave={t3} enter={t4}>{t5}{children}</TransitionRouter>;
    $[5] = children;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
export default TransitionWrapper;